const statPer90 = (stat, mins) => {
  return parseFloat(stat / (mins / 90)).toFixed(2)
}

export default statPer90